
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { authKeys, notificationKeys } from "~/features/auth/api/keys";
import { apiClient } from "~/lib/client";
import { handleError, handleResponse } from "~/utils/response";
import { UpdateNotificationSettingsData, UpdateUserProfileVariables } from "../../types";
import { UpdateNotificationSettings, UpdateNotificationSettingsResponse, UpdateUserProfileResponse, UpdateUserProfileResponseData } from "../types";

export const useUpdateUserProfile = () => {
  const queryClient = useQueryClient();

  return useMutation<UpdateUserProfileResponse, unknown, UpdateUserProfileVariables>({
    mutationFn: async (variables: UpdateUserProfileVariables) => {
      try {
        const response = await apiClient("/users", {
          method: "PUT",
          body: JSON.stringify(variables),
        });

        return await handleResponse<UpdateUserProfileResponseData>(response);
      } catch (error) {
        return handleError(error);
      }
    },
    onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: authKeys.me() });
      },
  });
};

export const useUpdateNotificationSettings = () => {
  const queryClient = useQueryClient();

  return useMutation<
    UpdateNotificationSettingsResponse, // No response data expected
    unknown, // Error type
    UpdateNotificationSettingsData // Variables type
  >({
    mutationFn: async (variables: UpdateNotificationSettingsData) => {
      try {
        const response = await apiClient("/users/settings/notification", {
          method: "PUT",
          body: JSON.stringify(variables),
        });

        return await handleResponse<UpdateNotificationSettings>(response);
      } catch (error) {
        return handleError(error);
      }   
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationKeys.settings() }
    );
    toast.success("Notification Successfull!");
    },
  });
};